<template>
    <div
        v-if="jsonLdEvent"
        type="application/ld+json"
        v-html="jsonLdEventString" />
</template>

<script>

export default {
    name: "JsonLdEvent",
    props: {
        event: {
            type: Object
        },
        parentUrl: {
            type: String
        }
    },
    computed: {
        jsonLdEvent() {
            if (!(this.event && this.parentUrl)) return null
            if (!(this.event.startDate && this.event.endDate)) return null

            let eventUrl = null
            try {
                eventUrl = new URL(this.parentUrl)
            } catch (e) {
                return null
            }

            let organizer = null
            if (this.event.alternativeOrganizer?.name) {
                organizer = {
                    "@type": "Organization",
                    "name": this.event.alternativeOrganizer.name,
                    "url": this.event.alternativeOrganizer.url
                }
            } else if (this.event.organizer?.name) {
                organizer = {
                    "@type": "Organization",
                    "name": this.event.organizer.name,
                    "url": this.event.organizer.url
                }
            }

            let location = null
            if (this.event.isOnline && this.event.onlineLink) {
                location = {
                    "@type": "VirtualLocation",
                    "url": this.event.onlineLink
                }
            } else if (!this.event.isOnline && this.event.location) {
                location = {
                    "@type": "Place",
                    "name": this.event.location.name,
                    "address": this.event.location.address && {
                        "@type": "PostalAddress",
                        "streetAddress": this.event.location.address.street + (this.event.location.address.houseNumber ? (" " + this.event.location.address.houseNumber) : ""),
                        "addressLocality": this.event.location.address.city,
                        "postalCode": this.event.location.address.zip,
                        "addressCountry": this.event.location.address.country
                    }
                }
            } else {
                return null
            }

            eventUrl.searchParams.set("eventId", this.event.id)
            const startDate = this.$moment(this.event.startDate)
            const endDate = this.$moment(this.event.endDate)
            let startDateFormatted = null
            let endDateFormatted = null
            if (startDate.isSame(startDate.clone().startOf('day')) && endDate.isSame(endDate.clone().startOf('day'))) {
                startDateFormatted = startDate.format("YYYY-MM-DD")
                endDateFormatted = endDate.format("YYYY-MM-DD")
            } else {
                startDateFormatted = startDate.toISOString()
                endDateFormatted = endDate.toISOString()
            }

            return {
                "@context": "https://schema.org",
                "@type": "Event",
                "eventStatus": "https://schema.org/EventScheduled",
                "name": this.event.name,
                "startDate": startDateFormatted,
                "endDate": endDateFormatted,
                "eventAttendanceMode": this.event.isOnline ? "https://schema.org/OnlineEventAttendanceMode" : "https://schema.org/OfflineEventAttendanceMode",
                "location": location || null,
                "image": this.event.images?.map(image => image.url),
                "description": this.event.description,
                "organizer": organizer || null,
                "url": eventUrl.href
            }
        },
        jsonLdEventString() {
            if (!this.jsonLdEvent) return ''
            // put the JSON-LD in a script tag
            const event = JSON.stringify(this.jsonLdEvent)
            const script = 'script'
            return `<${script}>${event}</${script}>`
        }
    }
}
</script>

<style scoped>

</style>
